import { getLocales } from 'react-native-localize';

import LANGUAGES_NAMES from 'utils/Language/languageNames';

export default function getDefaultLanguage(): keyof typeof LANGUAGES_NAMES {
    const locale = getLocales();

    if (
        locale?.[0].languageCode === 'hu' ||
        locale?.[0].languageCode === 'en'
    ) {
        return locale[0].languageCode as keyof typeof LANGUAGES_NAMES;
    }

    return 'hu' as keyof typeof LANGUAGES_NAMES;
}
